__turbopack_context__.v({
  "contentWrapper": "toggleFlexibleForm-module-scss-module___YwBDG__contentWrapper",
  "firstBreadcrumb": "toggleFlexibleForm-module-scss-module___YwBDG__firstBreadcrumb",
  "followingBreadcrumbs": "toggleFlexibleForm-module-scss-module___YwBDG__followingBreadcrumbs",
  "formBreadcrumbStyles": "toggleFlexibleForm-module-scss-module___YwBDG__formBreadcrumbStyles",
  "mainWrapper": "toggleFlexibleForm-module-scss-module___YwBDG__mainWrapper",
  "toggleButtonLabelStyles": "toggleFlexibleForm-module-scss-module___YwBDG__toggleButtonLabelStyles",
  "togglePanelContainer": "toggleFlexibleForm-module-scss-module___YwBDG__togglePanelContainer",
  "toggleTab": "toggleFlexibleForm-module-scss-module___YwBDG__toggleTab",
  "toggleTabList": "toggleFlexibleForm-module-scss-module___YwBDG__toggleTabList",
  "toggleTabSelected": "toggleFlexibleForm-module-scss-module___YwBDG__toggleTabSelected",
});
